/* tslint:disable */
/* eslint-disable */
/**
 * TOM STORAGE SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BerthDto } from '../model';
// @ts-ignore
import type { SetBerthGeometryCommand } from '../model';
/**
 * BerthGeometriesApi - axios parameter creator
 */
export const BerthGeometriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {SetBerthGeometryCommand} [setBerthGeometryCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        berthGeometriesSet: async (setBerthGeometryCommand?: SetBerthGeometryCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/BerthGeometries/Set`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setBerthGeometryCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BerthGeometriesApi - functional programming interface
 */
export const BerthGeometriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BerthGeometriesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {SetBerthGeometryCommand} [setBerthGeometryCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async berthGeometriesSet(setBerthGeometryCommand?: SetBerthGeometryCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BerthDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.berthGeometriesSet(setBerthGeometryCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BerthGeometriesApi.berthGeometriesSet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BerthGeometriesApi - factory interface
 */
export const BerthGeometriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BerthGeometriesApiFp(configuration)
    return {
        /**
         * 
         * @param {BerthGeometriesApiBerthGeometriesSetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        berthGeometriesSet(requestParameters: BerthGeometriesApiBerthGeometriesSetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<BerthDto> {
            return localVarFp.berthGeometriesSet(requestParameters.setBerthGeometryCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for berthGeometriesSet operation in BerthGeometriesApi.
 */
export interface BerthGeometriesApiBerthGeometriesSetRequest {
    readonly setBerthGeometryCommand?: SetBerthGeometryCommand
}

/**
 * BerthGeometriesApi - object-oriented interface
 */
export class BerthGeometriesApi extends BaseAPI {
    /**
     * 
     * @param {BerthGeometriesApiBerthGeometriesSetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public berthGeometriesSet(requestParameters: BerthGeometriesApiBerthGeometriesSetRequest = {}, options?: RawAxiosRequestConfig) {
        return BerthGeometriesApiFp(this.configuration).berthGeometriesSet(requestParameters.setBerthGeometryCommand, options).then((request) => request(this.axios, this.basePath));
    }
}

